import { InjectionKey, inject } from "vue";

export function injectRequired<T>(key: InjectionKey<T> | string): T {
  const requiredDepedency = inject<T>(key);
  if (!requiredDepedency) throw new Error(`${key} must be provided to use this component.`);
  return requiredDepedency;
}
